import type { CourseHomeCourse } from "@/lib/api/courseHome";
import { zoneCity } from "@/lib/seat-workspace";

/** One course band reads the same on the Desk and every view (#1416). */
export function courseBandMeta(course: Pick<CourseHomeCourse, "crn" | "timezone">, sectionTag: string | null): string {
  return [
    sectionTag?.startsWith("CRN ") ? null : sectionTag,
    course.crn ? `CRN ${course.crn}` : null,
    `Times in ${zoneCity(course.timezone)}`,
  ].filter((value): value is string => value !== null).join(" · ");
}
